import { Button } from '@/components/atoms/Button';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ComparisonCardContainerProps {
  height?: string;
  marginTop?: string;
}

export const ComparisonCardContainer = styled(Paper)<ComparisonCardContainerProps>(
  ({ theme, height, marginTop }) => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height,
    marginTop,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0),
      border: 'none',
    },
  })
);

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '36px',
  padding: theme.spacing(1, 2.5),
  borderColor: theme.palette.action.active,
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.action.active,
    backgroundColor: theme.palette.action.hover,
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: 1,
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));
